import { render } from "./childrens.vue?vue&type=template&id=6a7a8338"
import script from "./childrens.vue?vue&type=script&lang=js"
export * from "./childrens.vue?vue&type=script&lang=js"

import "./childrens.vue?vue&type=style&index=0&id=6a7a8338&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__